<div class="sidebar-container" [class.collapsed]="isCollapsed">

  @if (!isMobile) {
    <button
      class="toggle-button p-d-none p-d-md-block"
      (click)="toggleSidebar()"
      tooltipPosition="right">
      <img
        [src]="getIconPath(isCollapsed ? 'side-menu-trigger-off' : 'side-menu-trigger-on')"
        [alt]="isCollapsed ? 'Expand' : 'Collapse'"
        width="24"
        height="24" />
    </button>
  }


   <div class="side-menu-wrapper" [class.collapsed]="isCollapsed">
      <div class="menu-section card">
      <p-menu 
         [model]="menuItems" 
         [styleClass]="'custom-menu' + (isCollapsed ? ' collapsed-menu' : '')">
         <ng-template pTemplate="item" let-item>
            <a 
               [routerLink]="item.disabled ? null : item.routerLink" 
               [class.p-disabled]="item.disabled"
               [class.active-menu-item]="isActiveRoute(item)"
               class="menu-item-link"
               [pTooltip]="isCollapsed ? (item.label | translate) : null"
               tooltipPosition="right"
               (click)="selectMenu(item)">
               <img 
                  [src]="getIconPath(item.customIcon)" 
                  [alt]="item.label"
                  class="menu-icon" />
               <span class="menu-label" *ngIf="!isCollapsed">{{ item.label | translate }}</span>
            </a>
         </ng-template>
      </p-menu>
      </div>
      
      <div class="settings-section card">
      <p-menu 
         [model]="settingsMenuItems" 
         [styleClass]="'custom-menu' + (isCollapsed ? ' collapsed-menu' : '')">
         <ng-template pTemplate="item" let-item>
            <a 
               [routerLink]="item.disabled ? null : item.routerLink" 
               [class.p-disabled]="item.disabled"
               class="menu-item-link"
               [pTooltip]="isCollapsed ? (item.label | translate) : null"
               tooltipPosition="right">
               <img 
                  [src]="getIconPath(item.customIcon)" 
                  [alt]="item.label"
                  class="menu-icon" />
               <span class="menu-label" *ngIf="!isCollapsed">{{ item.label | translate }}</span>
            </a>
          
         </ng-template>
      </p-menu>
       <div class="logo-section" [class.collapsed-logo]="isCollapsed">
         <app-icon 
            [icon]="isCollapsed ? 'logo-digitagro-min' : 'logo-digitagro-max'" 
            [width]="isCollapsed ? 24 : 235" 
            [height]="isCollapsed ? 24 : 40" 
            [fixedSize]="true">
         </app-icon>
      </div>
      </div>
      
   </div>
</div>
